module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_1-69a6f9cae07881ac8a58572701e10ad7.jpg";